import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-bold text-primary-400">
                  韩漫
                </span>
                <span className="font-heading text-sm text-background-400 ml-1">
                  免费韩漫大全
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                韩漫网站是你的专属免费韩漫平台，支持韩漫在线阅读与无删减韩国漫画下拉式浏览，海量免费韩漫大全无需注册就能看。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-100 mb-4">分类导航</h4>
              <div className="grid grid-cols-2 gap-2">
                {categories.filter((c) => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}韩漫
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-100 mb-4">热门推荐</h4>
              <div className="space-y-2">
                <Link to="/comic/time-traveler" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">时间旅行者</Link>
                <Link to="/comic/blade-of-destiny" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">命运之刃</Link>
                <Link to="/comic/secret-relationship" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">秘密关系</Link>
                <Link to="/comic/gangster-high" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">黑帮高校</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-100 mb-4">关于我们</h4>
              <div className="space-y-2">
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link>
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</Link>
                <p className="text-sm text-background-500">📧 contact@hanman.com</p>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 韩漫网站 - 免费韩漫在线阅读平台。所有内容仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-400 hover:text-primary-400 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-background-400 hover:text-primary-400 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-background-400 hover:text-primary-400 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}